/*
 * @Author: 黄智强
 * @Date: 2018-04-16 11:37:09
 * @Last Modified by: 黄智强
 * @Last Modified time: 2018-09-19 17:58:55
 * @说明：省市区(region)相关的所有接口地址定义
 */
// 获取服务列表
export const serviceServiceList = '/service/service-list'
// 获取会员服务数量
export const serviceUserServiceCount = '/service/user-service-count'
// 获取服务价格
export const serviceServicePrice = '/service/service-price'
// 获取会员服务列表
export const serviceUserServiceList = '/service/user-service-list'
// 获取失效服务数量
export const serviceGetWarningService = '/service/get-warning-service'
// 服务订购记录
export const serviceBuyRecord = '/service/get-service-record'
// 短信发送记录日志
export const serviceUserSmsLog = '/service/user-sms-log'
// 获取短信发送状态
export const serviceSmsStatus = '/service/sms-status'
// 获取空间流程使用日志
export const serviceStorageDataLog = '/service/storage-data-log'
// 获取空间流量类型
export const serviceStorageDataType = '/service/storage-data-type'
// 获取空间流量操作类型
export const serviceStorageDataActionType = '/service/storage-data-action-type'



// WEBPACK FOOTER //
// ./src/api/url/service.js